/**
 * The EditorForm component
 */
import React from 'react'
import { Field } from 'redux-form'
import FieldInput from '../../FieldInput'
import ReduxFormButton from '../../ReduxFormButton'
import ReduxFormButtonGroup from '../../ReduxFormButtonGroup'
import PropTypes from "prop-types";
import { Row, Col } from 'reactstrap';
import ColorSelectField from '../../ColorSelectField'
import FontSelectField from './FontSelectField'
import {FaItalic, FaBold, FaAlignLeft, FaAlignRight, FaAlignCenter} from 'react-icons/fa'

const isBoldAvailable = (line) => {
  const {font} = line
  let available = false
  const italicSelected = line.italic
  const styleType = italicSelected ? 'italic_bold' : 'bold'
  if (font && font.value && font.value.styles){
    var boldStyle = font.value.styles.filter(style => style.title === styleType);
    if(boldStyle.length) {
      available = boldStyle[0].available
    }
  }
  return available;
}

const isItalicAvailable = (line) => {
  const {font} = line
  let available = false
  const boldSelected = line.bold
  const styleType = boldSelected ? 'italic_bold' : 'italic'
  if (font &&  font.value && font.value.styles){
    var italicStyle = font.value.styles.filter(style => style.title === styleType);
    if(italicStyle.length) {
      available = italicStyle[0].available
    }
  }
  return available;

}

const allignmentOptions = [{
  label: 'left',
  value: 'start',
  icon: <FaAlignLeft />
},
{
  label: 'center',
  value: 'middle',
  icon: <FaAlignCenter />
},
{
  label: 'right',
  value: 'end',
  icon: <FaAlignRight />
}]

let LineSettings = (props, context) => {
  const {fonts, handleFontChange, materialSerie, lines, disabled} = props;
  
  return (
    <div>
      <div className="texteditor__sidebar__linesettinglabels small text-muted">
        <div className="texteditor__sidebar__linesetting__left">{context.t("line")}</div>
        <div className="texteditor__sidebar__linesetting__right">
          <Row className="texteditor__sidebar__linesettinglabels__1">
            <Col xs={6}>{context.t("color")}</Col>
            <Col xs={6}>{context.t("font")}</Col>
            
          </Row>
          <div className="texteditor__sidebar__linesettinglabels__2">
            <div>{context.t("bold/italic")}</div>
            <div>{context.t("orientation")}</div>
            <div>{context.t("relation")}</div>
            <div>{context.t("lineheight")}</div>
          </div>
        </div>
      </div>
      {props.fields.map((lineSetting, index) => 
        <div key={`${lineSetting}_key`} className="texteditor__sidebar__linesetting" >
          <div className="texteditor__sidebar__linesetting__left small text-muted">#{index+1}</div>
          <div className="texteditor__sidebar__linesetting__right">
            <Row className="texteditor__sidebar__linesetting__1">
              <Field type="hidden" name={`${lineSetting}.text`} component="input" />
              <Col xs={6}>
                {materialSerie && <Field className="texteditor__sidebar__linesetting__color" name={`${lineSetting}.color`} component={ColorSelectField} materialSerie={materialSerie}/> }
              </Col>
              <Col xs={6}>
                <Field disabled={disabled} name={`${lineSetting}.font`} component={FontSelectField} fonts={fonts} onChange={handleFontChange.bind(this, index)} />
              </Col>
            </Row>
            <div className="texteditor__sidebar__linesetting__2">
              <div>
                <Field 
                  name={`${lineSetting}.bold`} 
                  disabled={(lines && !isBoldAvailable(lines[index])) || disabled} 
                  className="texteditor__sidebar__linesetting__button" 
                  component={ReduxFormButton} 
                  size={'sm'} 
                  icon={ <FaBold /> }
                  text={context.t("Bold")}
                />
                <Field 
                  name={`${lineSetting}.italic`}
                  disabled={(lines && !isItalicAvailable(lines[index])) || disabled} 
                  className="texteditor__sidebar__linesetting__button"
                  component={ReduxFormButton}
                  size={'sm'}
                  icon={<FaItalic />}
                  text={context.t("Italic")}
                />
              </div>
              <Field disabled={disabled} name={`${lineSetting}.allignment`} className="texteditor__sidebar__linesetting__button" component={ReduxFormButtonGroup} size={'sm'} buttons={allignmentOptions}/>
              <Field disabled={disabled} className="texteditor__sidebar__linesetting__fontSize" type="number" name={`${lineSetting}.fontSize`} component={FieldInput} min={1} />
              <Field disabled={disabled} className="texteditor__sidebar__linesetting__lineheight" type="number" name={`${lineSetting}.lineHeight`} component={FieldInput} min={1} />
            </div>
          </div>
        </div>
      )}
    </div>
    
    
  )
}

/**  define proptype for the 'translation' function  */
LineSettings.contextTypes = {
  t: PropTypes.func
}

export default LineSettings